import React, { useState } from 'react';
import { Button, Popover, Select } from 'antd';
import { FilterOutlined } from '@ant-design/icons';
import OWAsyncSelect from '../ow_async_select/OWAsyncSelect';
import { nullSafeGetOrElse } from '../../utils/DataAccessUtils';

const POPOVER_BODY_STYLE = { width: 320 };
const anchorPopupToParent = (triggerNode: HTMLElement) =>
	triggerNode.parentElement || document.body;

const renderFilterBody = (filter, filtersStateSlice) => {
	const ComponentToRender = filter.component || OWAsyncSelect;
	const defaultRender = (entity) => (
		<Select.Option key={filter.keyAccessor(entity)} value={filter.valueAccessor(entity)}>
			{filter.renderItem(entity)}
		</Select.Option>
	);
	const value = filter.filtersValueAccessor(filtersStateSlice);

	return (
		<ComponentToRender
			allowClear
			mode={filter.mode}
			style={POPOVER_BODY_STYLE}
			placeholder={filter.placeholderText || filter.placeholder}
			stateSlice={filter.stateSlice}
			targetCollectionName={filter.targetCollectionName}
			value={value}
			valueAccessor={filter.valueAccessor}
			labelAccessor={filter.labelAccessor}
			renderRecord={filter.renderRecord || defaultRender}
			renderItem={filter.renderItem}
			onChange={filter.handleChange}
			fetchData={(searchText, targetCollectionName, pagination, sorting, filters, addTo) =>
				filter.fetch(
					{ name: searchText },
					targetCollectionName,
					pagination,
					sorting,
					filters,
					addTo
				)
			}
			fetchMultiple={filter.fetchMultiple ? (...args) => filter.fetchMultiple(...args) : undefined}
			getPopupContainer={anchorPopupToParent}
			selectProps={{ getPopupContainer: anchorPopupToParent }}
		/>
	);
};

export default function PrivateNetworkLocationsFilterBar({ filterConfig, filtersStateSlice }) {
	const [openKey, setOpenKey] = useState<string | null>(null);

	return (
		<div className="flex flex-row items-center gap-2">
			{filterConfig.map((filter) => {
				const selected = filter.filtersValueAccessor(filtersStateSlice);
				const count = nullSafeGetOrElse('length', selected, 0);
				const label = count > 0 ? `${filter.label} (${count})` : filter.label;
				return (
					<Popover
						key={filter.fieldName}
						trigger="click"
						placement="bottomLeft"
						visible={openKey === filter.fieldName}
						onVisibleChange={(visible) => setOpenKey(visible ? filter.fieldName : null)}
						content={renderFilterBody(filter, filtersStateSlice)}
						destroyTooltipOnHide
					>
						<Button
							size="large"
							icon={<FilterOutlined translate="" />}
							type={count > 0 ? 'primary' : 'default'}
						>
							{label}
						</Button>
					</Popover>
				);
			})}
		</div>
	);
}
